import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "../images/urban.avif";

function Header() {
  return (
    <>
      <Navbar
        className="quattrocento-sans-regular App-bg-color-dark"
        expand="lg"
        sticky="top"
        data-bs-theme="dark"
      >
        <Container>
          <Navbar.Brand href="/">
            <img
              src={logo}
              height="60"
              width="auto"
              className="d-inline-block align-top"
              alt="React Bootstrap logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-center"
          >
            <Nav>
              <Nav.Link style={{ color: "whitesmoke" }} href="/architecture">
                Architecture
              </Nav.Link>
              <Nav.Link
                style={{ color: "whitesmoke" }}
                href="/construction"
              >
                Construction
              </Nav.Link>
              <Nav.Link style={{ color: "whitesmoke" }} href="/interiordesign">
                Interior Design
              </Nav.Link>
              <Nav.Link style={{ color: "whitesmoke" }} href="/fitout">
                Fit-Out{" "}
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
